<template>
  <div class="relative flex flex-col overflow-hidden rounded-xl shadow h-full w-full">
    <div class="-m-4 flex-grow">
      <iframe ref="iframe" class="w-full h-full" :src="src" frameborder="0"></iframe>
    </div>
    <transition name="fade">
      <div class="flex justify-center items-center bg-geb-gray-25 absolute inset-0" v-if="!loaded">
        <i class="animate-spin h-15 w-15 text-white fill-none" v-icon:tw-spin></i>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "VChatIframe",
  props: {
    src: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      loaded: false
    }
  },
  mounted() {
    const $iframe = this.$refs["iframe"];
    $iframe.addEventListener("load", () => {
      this.loaded = true;
    })
  }

}
</script>

<style lang="scss" scoped></style>